import { render, staticRenderFns } from "./TaskBoard.vue?vue&type=template&id=5ad9aa82&scoped=true&"
import script from "./TaskBoard.vue?vue&type=script&lang=js&"
export * from "./TaskBoard.vue?vue&type=script&lang=js&"
import style0 from "./TaskBoard.vue?vue&type=style&index=0&id=5ad9aa82&lang=less&scoped=true&"
import style1 from "./TaskBoard.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad9aa82",
  null
  
)

export default component.exports